<template>
  <div id="app">
    <div class="head">
      <div class="head-left">
        <div class="nav" @click="changeMenu()">
          <button class="btn-nav">
            <span class="icon-bar top"></span>
            <span class="icon-bar middle"></span>
            <span class="icon-bar bottom"></span>
          </button>
        </div>
        <span class="btn-text">{{ vuetiltle }}</span>
      </div>
      <div class="head-center">
        <img src="../../assets/img/logo.png" alt />
        <span>好运吧</span>
      </div>
      <div class="head-right"></div>

      <div class="nav-content hideNav hidden">
        <ul class="nav-list">
          <li class="nav-item">
            <a  @click="toMemu(1)" class="item-anchor">首页</a>
          </li>
          <li class="nav-item">
            <a h @click="toMemu(2)" class="item-anchor">产品功能</a>
          </li>
          <li class="nav-item">
            <a h @click="toMemu(3)" class="item-anchor">资讯中心</a>
          </li>
          <li class="nav-item">
            <a  @click="toMemu(4)" class="item-anchor">帮助中心</a>
          </li>
          <li class="nav-item">
            <a  @click="toMemu(5)" class="item-anchor">关于我们</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";

export default {
  // metaInfo: {
  //   title: "好运吧"
  // },
  name: "app",
  data() {
    return {
      msg: "注册协议Index",
       vuetiltle: this.title
    };
  },
  props: {
    title: String,
  },
  methods: {
    changeMenu() {
      $(".nav-content")
        .toggleClass("showNav hideNav")
        .removeClass("hidden");
      $(".btn-nav").toggleClass("animated");
    },
    toMemu(type) {
      console.log(type)
      if (type == 1) {
        this.$router.push("/index");
      } else if (type == 2) {
        this.$router.push("/product");
      } else if (type == 3) {
        window.location.href ="https://www.haoyunba.com/news-4.html";
      } else if (type == 4) {
       this.$router.push("/question");
      } else if (type == 5) {
         this.$router.push("/about");
      }
    }
  },

  components: {}
};
</script>
<style  scoped>
/* Clearfix hack by Nicolas Gallagher: http://nicolasgallagher.com/micro-clearfix-hack/ */
.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}

body {
  font-weight: 500;
  font-size: 1.05em;
  font-family: "Microsoft YaHei", "宋体", "Segoe UI", "Lucida Grande", Helvetica,
    Arial, sans-serif, FreeSans, Arimo;
}
a {
  color: #2fa0ec;
  text-decoration: none;
  outline: none;
}
a:hover,
a:focus {
  color: #74777b;
}

.htmleaf-container {
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
}
/* Header */
.htmleaf-header {
  padding: 1em 190px 1em;
  letter-spacing: -1px;
  text-align: center;
}
.htmleaf-header h1 {
  color: #d5d6e2;
  font-weight: 600;
  font-size: 2em;
  line-height: 1;
  margin-bottom: 0;
  font-family: "Microsoft YaHei", "宋体", "Segoe UI", "Lucida Grande", Helvetica,
    Arial, sans-serif, FreeSans, Arimo;
}
.htmleaf-header h1 span {
  font-family: "Microsoft YaHei", "宋体", "Segoe UI", "Lucida Grande", Helvetica,
    Arial, sans-serif, FreeSans, Arimo;
  display: block;
  font-size: 60%;
  font-weight: 400;
  padding: 0.8em 0 0.5em 0;
  color: #c3c8cd;
}

.nav {
  position: relative;
  width: auto;
  display: flex;
  border: none;
  justify-content: center;
  align-items: center;
}

.btn-nav {
  position: fixed;
  /* top: 50px;
  left: 30px; */

  background: transparent;
  border: none;
  padding: 10px;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  cursor: pointer;
  z-index: 99999;
}

.btn-nav:focus {
  outline: 0;
}

.icon-bar {
  display: block;
  margin: 6px 0;
  width: 40px;
  height: 5px;
  background-color: #006cff;
}

.btn-nav:hover .icon-bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
  background-color: #006cff;
}

.nav-content {
  position: fixed;
  top: -100%;
  bottom: 0;
  left: 0;
  right: 0;
  background: #000000;
  display: block;
  height: 100%;
  opacity: 0.7;
  z-index: 9;
}

.nav-list {
  list-style: none;
  padding: 0;
  position: relative;
  top: 30%;
}

.item-anchor:after {
  content: "";
  position: absolute;
  width: 3px;
  height: 3px;
  left: 0;
  bottom: 0;
  z-index: 9;
  background: transparent;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}

.item-anchor {
  color: #fff;
  font-size: 30px;
  text-transform: uppercase;
  position: relative;
  text-decoration: none;
  padding: 10px;
}

.item-anchor:hover,
.item-anchor:focus {
  color: #006cff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}

.item-anchor:hover:after,
.item-anchor:focus:after {
  width: 100%;
  background: #006cff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}

.nav-item {
  margin: 40px auto;
  text-align: center;
}

.animated {
  display: block;
  margin: 0 auto;
}

.animated:hover .icon-bar,
.animated:focus .icon-bar {
  background-color: #006cff;
}

.animated:focus {
  cursor: pointer;
  z-index: 9999;
}

.middle {
  margin: 0 auto;
}

.icon-bar {
  -webkit-transition: all 0.7s ease;
  -moz-transition: all 0.7s ease;
  -ms-transition: all 0.7s ease;
  -o-transition: all 0.7s ease;
  transition: all 0.7s ease;
  z-index: 999999;
}

.animated .icon-bar {
  z-index: 999999;
  background-color: #006cff;
}

.animated .top {
  -webkit-transform: translateY(10px) rotateZ(45deg);
  -moz-transform: translateY(10px) rotateZ(45deg);
  -ms-transform: translateY(10px) rotateZ(45deg);
  -o-transform: translateY(10px) rotateZ(45deg);
  transform: translateY(10px) rotateZ(45deg);
}

.animated .bottom {
  -webkit-transform: translateY(-11px) rotateZ(-45deg);
  -moz-transform: translateY(-11px) rotateZ(-45deg);
  -ms-transform: translateY(-11px) rotateZ(-45deg);
  -o-transform: translateY(-11px) rotateZ(-45deg);
  transform: translateY(-11px) rotateZ(-45deg);
}

.animated .middle {
  width: 0;
}

@keyframes showNav {
  from {
    top: -100%;
  }
  to {
    top: 0;
  }
}

@-webkit-keyframes showNav {
  from {
    top: -100%;
  }
  to {
    top: 0;
  }
}

@-moz-keyframes showNav {
  from {
    top: -100%;
  }
  to {
    top: 0;
  }
}

@-o-keyframes showNav {
  from {
    top: -100%;
  }
  to {
    top: 0;
  }
}

.showNav {
  -webkit-animation: showNav 1s ease forwards;
  -moz-animation: showNav 1s ease forwards;
  -o-animation: showNav 1s ease forwards;
  animation: showNav 1s ease forwards;
}

@keyframes hideNav {
  from {
    top: 0;
  }
  to {
    top: -100%;
  }
}

@-webkit-keyframes hideNav {
  from {
    top: 0;
  }
  to {
    top: -100%;
  }
}

@-moz-keyframes hideNav {
  from {
    top: 0;
  }
  to {
    top: -100%;
  }
}

@-o-keyframes hideNav {
  from {
    top: 0;
  }
  to {
    top: -100%;
  }
}

.hideNav {
  -webkit-animation: hideNav 1s ease forwards;
  -moz-animation: hideNav 1s ease forwards;
  -o-animation: hideNav 1s ease forwards;
  animation: hideNav 1s ease forwards;
}

.hidden {
  display: none;
}

/****同步信息 */
#app {
  width: 750px;
  background: #ffffff;
}
.head {
  width: 750px;
  height: 110px;
  display: flex;
  margin: 0;
  padding: 0;
  position: fixed;
  top: 0;
  left: 0;
  background: #ffffff;
  border: 1px solid #EEEEEE;
  z-index: 99999;

}
.head-left {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-text {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 27px;
  margin-left: 31px;
}

.menu-list {
  width: 243px;
  height: 473px;
  background: #000000;
  opacity: 0.7;
  position: absolute;
}

.head-right {
  flex: 1;
}
.head-center {
  width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.head-center img {
  width: 60px;
  height: 60px;
}
.head-center span {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 27px;
  display: inline-block;
  margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/common/head.vue